import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter026() {
  return <KbChapterPage slug="chapter-026" />;
}

(Chapter026 as unknown as { path: string }).path = "/theory-album/026";
